import Vue from 'vue'
import Router from 'vue-router'

import Welcome from '../WelcomeComponent';
import InterParcel from '../InterParcel';

import LegalMentions from '../LegalMentions.vue';


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      //redirect: 'welcome',
      component: Welcome,
      meta: {
        notInSideBar: true,
        notInToolBar: true
      }
    },
    {
      path: '/InterParcel',
      name: 'InterParcel',
      component: InterParcel,
      meta: {
        // Add this to take off that child of SideBar component :
        // notInSideBar: true,
        //icon: 'mdi-map',
        //notInToolBar: true
      }
    },
    
    {
      path: '/legalMentions',
      name: 'LegalMentions',
      component: LegalMentions
    },
  ]
})
